import * as React from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {IconCard} from '../../../ui/Icons'
import {isCreditCardPaymentMethod, PaymentMethod} from '@raisenow/epik'

///////////////////////////////////////////////////////////////////////////////

export const TransactionInfoPaymentMethodDetails = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const transactionInfo = api.transactionInfo

  if (!transactionInfo) {
    return null
  }

  let paymentMethod = transactionInfo.payment_method
  const isCreditCard = isCreditCardPaymentMethod(paymentMethod)
  const expm = transactionInfo.expm
  const expy = transactionInfo.expy

  if (isCreditCard) {
    paymentMethod = PaymentMethod.CREDIT_CARD
  }

  return (
    <section className="payment-method-details">
      <div className="header">
        <div className="title">
          <h2 className="text">
            {api.trans('blocks.transaction_info.payment_method_details.title')}
          </h2>
          <span className="icon" role="presentation">
            <IconCard />
          </span>
        </div>
      </div>

      <p className="main">
        <span className="payment-method">
          {api.trans(`payment_methods.${paymentMethod}`)}
        </span>
        {isCreditCard && expm && expy && (
          <span className="expm-expy">
            {api.trans(
              'blocks.transaction_info.payment_method_details.valid_until',
            )}
            : {expm}/{expy}
          </span>
        )}
      </p>
    </section>
  )
})
